import { mutate, query } from '@/api/graphql';
import { always, mapObjIndexed, when } from 'ramda';
import gql from 'graphql-tag';
import isNullOrEmpty from '@/helpers/misc/isNullOrEmpty';
import ActiveUser from '@/api/user/graphql/fragments/activeUser.graphql';
import GetAgencyArchives from './graphql/queries/GetAgencyArchives.graphql';
import HasAgencyContentBeenUsed from './graphql/queries/HasAgencyContentBeenUsed.graphql';
import SaveAgencyArchive from './graphql/mutations/SaveAgencyArchive.graphql';
import AgencyArchives from './graphql/fragments/agencyArchives.graphql';
import GetActiveUsersOfAgencyArchives from './graphql/queries/GetActiveUsersOfAgencyArchives.graphql';

export const getAgencyArchives = async ({
  filter, page, limit, firstCreatedDate,
}) => {
  const modifiedFilter = mapObjIndexed(when(isNullOrEmpty, always(undefined)), filter);
  const language = localStorage.getItem('selectedLocale');

  const variables = {
    filter: modifiedFilter,
    page,
    limit,
    firstCreatedDate,
    language,
  };

  const { agencyArchives } = await query(gql`
    ${GetAgencyArchives}
    ${AgencyArchives}
  `, variables);

  return agencyArchives;
};

export const getActiveUsersOfAgencyArchive = async () => {
  const { activeUsersOfAgencyArchives } = await query(gql`
    ${GetActiveUsersOfAgencyArchives}
    ${ActiveUser}
  `);

  return activeUsersOfAgencyArchives;
};

export const saveAgencyArchive = async input => {
  const variables = {
    input,
  };

  const result = await mutate(gql`
    ${SaveAgencyArchive}
    ${AgencyArchives}
    `,
  variables);

  return result;
};

export const hasAgencyContentBeenUsed = async agencyContentId => {
  const variables = {
    agencyContentId,
  };

  const result = await query(gql`
    ${HasAgencyContentBeenUsed}
  `, variables);

  return result;
};
